import React from 'react';
import '../style/About.scss';
// component
import Header from '../components/public/Header';
// React Bootstrap
import { Container, Row, Col, Image } from 'react-bootstrap';
// react redux
import { connect } from 'react-redux';

// import Gallery from 'react-photo-gallery';
import PhotoGallery from '../components/thirdParty/PhotoGallery';

function About({ lang }) {
  const tibetanCalligraphy = [
    {
      // no 2
      src: 'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fexhibition2.jpg?alt=media&token=f39e277d-c779-42d1-92be-63aa0550046b',
      width: 5,
      height: 3,
    },
    {
      // no 1
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fexhibition1.jpg?alt=media&token=ea1c06f2-08ac-425c-9963-908a7a19651f',
      width: 5,
      height: 3,
    },
    {
      // no 12
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fexhibition12.jpg?alt=media&token=2aea4636-bcc5-41a9-b166-3a4b25869511',
      width: 2,
      height: 3,
    },
    {
      // no 3
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fexhibition3.jpg?alt=media&token=6c033676-2e0c-4aad-9292-26b127b3e4dc',
      width: 4,
      height: 3,
    },
    {
      // no 5
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fexhibition5.jpg?alt=media&token=768d12b8-444e-4124-b105-d7d93dabd998',
      width: 5,
      height: 3,
    },
    {
      //no 4 
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fexhibition4.jpg?alt=media&token=e7946cf3-a5a3-40be-a039-6c0c8830ce5a',
      width: 3,
      height: 5,
    },

    {
      //no 6 
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fexhibition6.jpg?alt=media&token=9e5acd8e-fff6-4e25-ad5d-946d8998033e',
      width: 5,
      height: 3,
    },
    {
      //no 8 
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fexhibition8.jpg?alt=media&token=ac80a485-ebaa-4f24-a7c2-a4ec830f7afd',
      width: 5,
      height: 3,
    },
    {
      //no 9 
      src:
        ' https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fexhibition9.jpg?alt=media&token=d1f81865-b0c9-4107-8b27-061e5246c801',
      width: 5,
      height: 3,
    },
    {
      //no 10 
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fexhibition10.jpg?alt=media&token=4bb8bf48-6725-4108-92e5-3305da87c37d',
      width: 5,
      height: 3,
    },
    {
      //no 11 
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fexhibition11.jpg?alt=media&token=4ce87bdb-8ae2-4a2c-8d98-2ecf568e61e3',
      width: 5,
      height: 3,
    },
    {
      //no 13 
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fexhibition13.jpg?alt=media&token=d58747e2-e52f-44b7-bfa4-767b744779e5',
      width: 5,
      height: 3,
    },
    {
      //no 14 
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fexhibition14.jpg?alt=media&token=be80e9b9-f541-410b-92bf-f3bd4dd2fd1e',
      width: 5,
      height: 3,
    },
    {
      //no 15 
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fexhibition15.jpg?alt=media&token=d5039816-4fb6-47b9-8059-01b08dd98a08',
      width: 3,
      height: 4,
    },
    {
      //no 16 
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fexhibition16.jpg?alt=media&token=9da21db3-f198-456a-9b34-177a8e654b30',
      width: 3,
      height: 4,
    },
    {
      //no 17 
      src:
        ' https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fexhibition17.jpg?alt=media&token=6fbe091e-903a-4f78-a9c5-40717f11086a',
      width: 3,
      height: 4,
    },
    {
      //no 18 
      src:
        'https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fexhibition18.jpg?alt=media&token=aa6a3538-894c-4909-8254-378634226b96',
      width: 5,
      height: 3,
    },
  ];
  return (
    <>
      <Header />
      <Container className='about'>
        <div className='aboutBody p-5'>
          <Row>
            <Col>
              {lang === 'CH' ? (
                <h3 className='text-left text-secondary chinese'>
                  作品展出
                </h3>
              ) : lang === 'TIB' ? (
                <h3 className='text-left text-secondary tibetan_Dutsa'>
                  བོད་ཡིག
                </h3>
              ) : (
                    <h3 className='text-left text-secondary'>
                      English
                    </h3>
                  )}
            </Col>
          </Row>
          <Row>
            <Col>
              <Image
                src='https://firebasestorage.googleapis.com/v0/b/kunga-58b60.appspot.com/o/images%2Fexhibition7.jpg?alt=media&token=e8d3e7ff-da19-4f6d-9899-68bc40501f75                '
                fluid
              />
            </Col>
          </Row>
          <Row className='aboutContent d-flex align-items-center justify-content-center'>
            <Col className='align-items-center  justify-content-center'>
              <PhotoGallery images={tibetanCalligraphy} />
            </Col>
          </Row>
        </div>
      </Container>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    lang: state.lang.lang,
  };
};

export default connect(mapStateToProps)(About);
